var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sip-drawer-host", attrs: { hidden: !_vm.open } },
    [
      _vm.open
        ? _c(
            "div",
            {
              staticClass: "sip-drawer-overlay",
              class: _vm.overlayClasses,
              style: _vm.overlayStyle,
              attrs: { role: "presentation" },
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.onBackdrop.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "aside",
                {
                  staticClass: "sip-drawer",
                  class: _vm.drawerClasses,
                  attrs: {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": _vm.titleId,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _vm.showHeader
                    ? _c("header", { staticClass: "sip-drawer-header" }, [
                        _c(
                          "h5",
                          {
                            staticClass: "sip-drawer-title",
                            attrs: { id: _vm.titleId },
                          },
                          [
                            _vm._t("title", function () {
                              return [
                                _vm.icon
                                  ? _c("em", {
                                      class: ["icon", "ni", _vm.icon, "me-2"],
                                      attrs: { "aria-hidden": "true" },
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.title) +
                                    "\n                    "
                                ),
                              ]
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.$slots.actions
                          ? _c(
                              "div",
                              { staticClass: "sip-drawer-header-actions" },
                              [_vm._t("actions")],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "sip-drawer-close",
                            attrs: {
                              type: "button",
                              "aria-label": _vm.closeLabel,
                            },
                            on: { click: _vm.close },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "16",
                                  height: "16",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "aria-hidden": "true",
                                },
                              },
                              [
                                _c("path", { attrs: { d: "M18 6 6 18" } }),
                                _vm._v(" "),
                                _c("path", { attrs: { d: "m6 6 12 12" } }),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { ref: "body", staticClass: "sip-drawer-body" },
                    [_vm._t("default")],
                    2
                  ),
                  _vm._v(" "),
                  _vm.$slots.footer
                    ? _c(
                        "footer",
                        { staticClass: "sip-drawer-footer" },
                        [_vm._t("footer")],
                        2
                      )
                    : _vm._e(),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }